import { connect } from 'react-redux';

import { getOfficesList, getOfficesShortList } from '../Offices/officesActions';
// Component
import { getOrganizationMembersList } from '../Projects/projectsActions';
import Selfie from './Selfie';
import { getSelfieList } from './selfieActions';

// Store props to map with current state
const mapStateToProps = state => ({
  selectedOrganization: state.organization.selectedOrganization,
  organizationMembersList: state.project.orgMembersList,
  isSelfieLoading: state.selfie.isSelfieLoading,
  selfieList: state.selfie.selfieList,
  selfieCount: state.selfie.selfieCount,
  pageSize: state.selfie.selfieListPageSize,
  officesList: state.office.officesList,
  isOfficeLoading: state.office.isLoading,
  officesShortList: state.office.officesShortList,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getOrganizationMembersList: params =>
    dispatch(getOrganizationMembersList(params)),
  getOfficesList: params => dispatch(getOfficesList(params)),
  getSelfieList: details => dispatch(getSelfieList(details)),
  getOfficesShortList: params => dispatch(getOfficesShortList(params)),

  // setOfficeDetails: params => dispatch(setOfficeDetails(params)),
  //   getPublicZoneList: params => dispatch(getPublicZoneList(params)),
  //   clearOfficeCreatedUpdated: () => dispatch(clearOfficeCreatedUpdated()),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(Selfie);
